import { Circle } from "react-konva";

const problemColor = "rgb(220,38,38)" /* text-red-600, same red as the "Problem" label */;
const resolvedColor = "rgb(22,163,74)" /* text-green-600, the problem was checked */;

// A read-only reference dot for an open problem on the 2D model - where it was found, not editable (not
// draggable, no delete): distinct from Marking.js (this trip's own markings, draggable, numbered).
const ProblemMarking = ({
  data,
  parent_width,
  parent_height,
  highlighted,
  resolved,
}) => {
  const [x, y] = data.marking_kordinat.split(",").map((el) => parseFloat(el));

  return (
    <Circle
      x={parent_width * x}
      y={parent_height * y}
      width={highlighted ? 52 : 36}
      height={highlighted ? 52 : 36}
      stroke={resolved ? resolvedColor : problemColor}
      strokeWidth={highlighted ? 5 : 3}
      // highlighted: a bigger solid ring with a filled centre, so it stands out from the other problems
      fill={
        highlighted
          ? resolved
            ? "rgba(22,163,74,0.25)"
            : "rgba(220,38,38,0.25)"
          : undefined
      }
      dash={highlighted ? undefined : [5, 4]}
      listening={false}
    />
  );
};

export default ProblemMarking;
